import {IMagnetToolWizardState} from "../../../types/ui/wizard/magnet-tool";

export const initialMagnetToolState: IMagnetToolWizardState = {
  visible: false,
  height: 250,
  width: 200,
  x: 0,
  y: 0
};
